import programs from './programs';
import visitedSites from './visited-sites';
import printData from './print-data';
import downloadData from './download-data';

export default {
  namespaced: true,
  modules: {
    programs,
    visitedSites,
    printData,
    downloadData,
  },
};
